import { Card, Stack, Typography, CircularProgress, Box } from "@mui/joy";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";

interface SubmissionDetailsCardProps {
  exam: any;
  isPolling: boolean;
  examPolling: boolean;
  currentUserSubmission: any;
  submissionStatus: any;
}

export default function SubmissionDetailsCard({
  exam,
  isPolling,
  examPolling,
  currentUserSubmission,
  submissionStatus,
}: SubmissionDetailsCardProps) {
  return (
    <Stack spacing={2} sx={{ flex: 1}}>
      <Card
        sx={{
          flex: 1,
          height: { xs: "110px", sm: "90px" },
          position: "relative",
          pb: 4,
          background: currentUserSubmission?.submissionArtifact
            ? "#E8EAF6"
            : "transparent",
          border: currentUserSubmission?.submissionArtifact
            ? "none"
            : "1px solid #E0E0E0",
          overflow: "hidden",
          cursor: currentUserSubmission?.submissionArtifact
            ? "pointer"
            : "default",
          transition: "background-color 0.2s ease, transform 0.2s ease",
          width: { xs: "100%", sm: "auto" },
          "&:hover": currentUserSubmission?.submissionArtifact
            ? {
                backgroundColor: "#C5CAE9",
                transform: "scale(1.02)",
              }
            : {},
        }}
        onClick={() => {
          if (currentUserSubmission?.submissionArtifact) {
            window.open(
              currentUserSubmission.submissionArtifact,
              "_blank"
            );
          }
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography
            level="title-lg"
            sx={{
              mb: 2,
              color: currentUserSubmission?.submissionArtifact
                ? "#1A237E"
                : "#757575",
            }}
          >
            My Submission
          </Typography>
          {currentUserSubmission?.submissionArtifact && (
            <NorthEastIcon
              sx={{ mb: 2, color: "#1A237E", fontSize: 20 }}
            />
          )}
          {(isPolling || examPolling) && (
            <CircularProgress
              size="sm"
              sx={{ mb: 2, ml: 1 }}
              color="primary"
            />
          )}
        </Stack>
        <Typography
          level="body-sm"
          sx={{
            color: currentUserSubmission?.submissionArtifact
              ? "#1A237E"
              : "#757575",
          }}
        >
          {isPolling
            ? "Checking submission status..."
            : currentUserSubmission?.submissionArtifact
            ? `Submitted at: ${currentUserSubmission.updatedAt || " - "}`
            : submissionStatus?.submitted
            ? "Submission confirmed, refreshing..."
            : "Not submitted"}
        </Typography>
        <Box
          sx={{
            position: "absolute",
            bottom: "8%",
            right: "8%",
            opacity: 0.15,
            transform: "scale(2.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <DescriptionRoundedIcon sx={{ fontSize: 40 }} />
        </Box>
      </Card>
    </Stack>
  );
}
